<template>
  <div class="w-100 d-flex justify-content-center align-items-center login">
    <h1>Redirecting you...</h1>
  </div>
</template>

<script>
export default {
  mounted () {
    window.location.href = `${process.env.VUE_APP_TELLIMER_URL}forgot-password`
  },
}
</script>
